import './style.scss';

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const option = {
	slidesPerView: 2,
	enabled: true,
	pagination: {  //ページネーションを表示
		el: '.news-swiper-pagination',
		clickable: true,  //アイコンをクリックすると対応するスライドに移動
	},

	navigation: {  //ナビゲーションボタンを表示
		nextEl: '.news-swiper-button-next',
		prevEl: '.news-swiper-button-prev',
	},
	breakpoints: {
		// Swiper のコンテナ幅が 420px 以上の場合
		769: {
			enabled: false,
			slidesPerView: 0,
		},
	},
}

// init Swiper:
// eslint-disable-next-line no-unused-vars
const swiper = new Swiper('.news-list', option);

